module.exports = __webpack_public_path__ + "img/LogoBtnSave1.7805cd3b.png";